var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP2E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5295 14.5799C13.5295 7.03797 19.6476 0.924049 27.1946 0.924049H117.97C125.517 0.924049 131.635 7.03797 131.635 14.5799V105.294C131.635 112.835 125.517 118.949 117.97 118.949H27.1946C19.6476 118.949 13.5295 112.835 13.5295 105.294V14.5799Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.97 1.89947H27.1946C20.1867 1.89947 14.5056 7.57667 14.5056 14.5799V105.294C14.5056 112.297 20.1867 117.974 27.1946 117.974H117.97C124.978 117.974 130.659 112.297 130.659 105.294V14.5799C130.659 7.57668 124.978 1.89947 117.97 1.89947ZM27.1946 0.924049C19.6476 0.924049 13.5295 7.03797 13.5295 14.5799V105.294C13.5295 112.835 19.6476 118.949 27.1946 118.949H117.97C125.517 118.949 131.635 112.835 131.635 105.294V14.5799C131.635 7.03797 125.517 0.924049 117.97 0.924049H27.1946Z",
    fill: "#00CDF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9778 20.9378C20.9778 13.4079 27.0861 7.30379 34.621 7.30379H111.608C119.143 7.30379 125.251 13.4079 125.251 20.9378V97.8724C125.251 105.402 119.143 111.506 111.608 111.506H34.621C27.0861 111.506 20.9778 105.402 20.9778 97.8724V20.9378Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.608 8.27765H34.621C27.6243 8.27765 21.9523 13.9458 21.9523 20.9378V97.8724C21.9523 104.864 27.6243 110.532 34.621 110.532H111.608C118.605 110.532 124.277 104.864 124.277 97.8724V20.9378C124.277 13.9458 118.605 8.27765 111.608 8.27765ZM34.621 7.30379C27.0861 7.30379 20.9778 13.4079 20.9778 20.9378V97.8724C20.9778 105.402 27.0861 111.506 34.621 111.506H111.608C119.143 111.506 125.251 105.402 125.251 97.8724V20.9378C125.251 13.4079 119.143 7.30379 111.608 7.30379H34.621Z",
    fill: "#00CDF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4102 130.243C61.4102 129.433 60.7532 128.776 59.9428 128.776H15.9236C9.17046 128.776 3.69599 123.305 3.69599 116.557L3.69599 72.5676C3.69599 71.7578 3.03905 71.1013 2.22868 71.1013C1.4183 71.1013 0.761368 71.7578 0.761368 72.5676L0.761368 116.557C0.761368 124.925 7.54971 131.709 15.9236 131.709H59.9428C60.7532 131.709 61.4102 131.052 61.4102 130.243Z",
    fill: "#00CDF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2E);
export default __webpack_public_path__ + "static/media/p2e.681072c522e2c475053e31e3609d3e91.svg";
export { ForwardRef as ReactComponent };